import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import volumeDetector from "../utils/volume-detector";

const AudioLevelDetectorElement = styled.div`
  margin-top: 10px !important;
  margin-bottom: -10px !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 40px;
  padding-right: 42px;
  justify-content: space-between;
`;
const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--secondaryMuted);
`;

type Props = {
  stream?: MediaStream | null;
};
const AudioLevelDetector: React.FC<Props> = ({ stream }) => {
  const [numDots, setNumDots] = useState(1);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let num = 0;
    if (ref.current) {
      const el = ref.current;
      const width = el.offsetWidth;
      num = Math.min(Math.max(1, Math.floor(width / 12)), 12);
      setNumDots(num);

      if (stream) {
        return volumeDetector(stream, (volume) => {
          const activeDots = Math.floor((num / 100) * volume);
          const dots = Array.from(el.querySelectorAll("div"));
          dots.forEach((d, i) => {
            const active = i < activeDots;
            d.style.backgroundColor = active ? "var(--success)" : "";
          });
        });
      }
    }
  }, [stream]);
  return stream ? (
    <AudioLevelDetectorElement ref={ref}>
      {Array.from({ length: numDots }).map((_, i) => (
        <Dot key={i} />
      ))}
    </AudioLevelDetectorElement>
  ) : null;
};

export default AudioLevelDetector;
